import AccountingSystem from "./AccountingSystem";
export interface Income {
    item: string;
    row: string;
    yearCash: string;
    monthCash: string;
    lastYearMonthCash: string;
    fomularDetail: string | null;
    open?: string;
    closeNum?: string;
    openStatus?: boolean;
    oneQuarterCash?: string;
    twoQuarterCash?: string;
    threeQuarterCash?: string;
    fourQuarterCash?: string;
}
const thirteenRule: Income[] = [
    {
        item: "一、营业收入",
        row: "1",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：主营业务收入+其他业务收入"
    },
    {
        item: "减：营业成本",
        row: "2",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：主营业务成本+其他业务成本"
    },
    {
        item: "税金及附加",
        row: "3",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：税金及附加",
        open: "1",
        closeNum: "10",
        openStatus: true
    },
    {
        item: "　其中：消费税",
        row: "4",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交消费税"
    },
    {
        item: "　　　营业税",
        row: "5",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交营业税"
    },
    {
        item: "　　　城市维护建设税",
        row: "6",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交城市维护建设税"
    },
    {
        item: "　　　资源税",
        row: "7",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交资源税"
    },
    {
        item: "　　　土地增值税",
        row: "8",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交土地增值税"
    },
    {
        item: "　　　城镇土地使用税、房产税、车船税、印花税",
        row: "9",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：应交城镇土地使用税+应交房产税+应交车船使用税"
    },
    {
        item: "　　　教育费附加、矿产资源补偿费、排污费",
        row: "10",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail:
            "科目：地方教育费附加+教育费附加+矿产资源补偿费+排污费"
    },
    {
        item: "销售费用",
        row: "11",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：销售费用",
        open: "1",
        closeNum: "18",
        openStatus: true
    },
    {
        item: "　其中：商品维修费",
        row: "12",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：商品维修费"
    },
    {
        item: "　　　广告费和业务宣传费",
        row: "13",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：广告费+业务宣传费"
    },
    {
        item: "管理费用",
        row: "14",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：管理费用",
        open: "1",
        closeNum: "17",
        openStatus: true
    },
    {
        item: "　其中：开办费",
        row: "15",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：开办费"
    },
    {
        item: "　　　业务招待费",
        row: "16",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：业务招待费"
    },
    {
        item: "　　　研究费用",
        row: "17",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：研究费用"
    },
    {
        item: "财务费用",
        row: "18",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：财务费用",
        open: "1",
        closeNum: "19",
        openStatus: true
    },
    {
        item: "　其中：利息费用（收入以“-”号填列）",
        row: "19",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：利息费用"
    },
    {
        item: "加：投资收益（损失以“-”号填列）",
        row: "20",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：投资收益"
    },
    {
        item: "二、营业利润（亏损以“-”号填列）",
        row: "21",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行次：行1-行2-行3-行11-行14-行18+行20"
    },
    {
        item: "加：营业外收入",
        row: "22",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：营业外收入",
        open: "1",
        closeNum: "23",
        openStatus: true
    },
    {
        item: "　其中：政府补助",
        row: "23",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：政府补助"
    },
    {
        item: "减：营业外支出",
        row: "24",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：营业外支出",
        open: "1",
        closeNum: "29",
        openStatus: true
    },
    {
        item: "　其中：坏账损失",
        row: "25",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：坏账损失"
    },
    {
        item: "　　　无法收回的长期债券投资损失",
        row: "26",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：无法收回的长期债券投资损失"
    },
    {
        item: "　　　无法收回的长期股权投资损失",
        row: "27",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：无法收回的长期股权投资损失"
    },
    {
        item: "　　　自然灾害等不可抗力因素造成的损失",
        row: "28",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：自然灾害等不可抗力因素造成的损失"
    },
    {
        item: "　　　税收滞纳金",
        row: "29",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：税收滞纳金"
    },
    {
        item: "三、利润总额（亏损总额以“-”号填列）",
        row: "30",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行次：行21+行22-行24"
    },
    {
        item: "减：所得税费用",
        row: "31",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：所得税费用"
    },
    {
        item: "四、净利润（净亏损以“-”号填列）",
        row: "32",
        yearCash: "0",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行次：行30-行31"
    }
];

const sevenRule: Income[] = [
    {
        item: "一、营业收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "1",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：主营业务收入+其他业务收入"
    },
    {
        item: "减：营业成本",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "2",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：主营业务成本+其他业务成本"
    },
    {
        item: "　　税金及附加",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "3",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：税金及附加"
    },
    {
        item: "　　销售费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "4",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：销售费用"
    },
    {
        item: "　　管理费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "5",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "管理费用-研发科目"
    },
    {
        item: "　　研发费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "6",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: " 研究费用"
    },
    {
        item: "　　财务费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "7",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：财务费用"
    },
    {
        item: "  其中：利息费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "8",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "财务费用-利息费用科目实际损益额"
    },
    {
        item: "利息收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "9",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "财务费用-利息收入科目实际损益额"
    },
    {
        item: "加：其他收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "10",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "其他收益"
    },
    {
        item: "投资收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "11",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "投资收益"
    },
    {
        item: " 其中：对联营企业和合营企业的投资收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "12",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "公允价值变动收益（损失以“-”号填列） ",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "13",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "公允价值变动损益"
    },
    {
        item: " 资产减值损失（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "14",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "资产减值损失"
    },
    {
        item: " 资产处置收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "15",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "资产处置损益"
    },
    
    {
        item: "二、营业利润（亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "16",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "1-2-3-4-5-6-7+10+11+13+14+15"
    },
    {
        item: "加：营业外收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "17",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：营业外收入"
    },
    // {
    //     item: "　　其中：非流动资产处置利得",
    //     oneQuarterCash: "0",
    //     twoQuarterCash: "0",
    //     threeQuarterCash: "0",
    //     fourQuarterCash: "0",
    //     row: "15",
    //     yearCash: "0",
    //     monthCash: "0",
    //     lastYearMonthCash: "0",
    //     fomularDetail: null
    // },
    {
        item: "减：营业外支出",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "18",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：营业外支出"
    },
    // {
    //     item: "　　其中：非流动资产处置损失",
    //     oneQuarterCash: "0",
    //     twoQuarterCash: "0",
    //     threeQuarterCash: "0",
    //     fourQuarterCash: "0",
    //     row: "17",
    //     yearCash: "0",
    //     monthCash: "0",
    //     lastYearMonthCash: "0",
    //     fomularDetail: "科目：非流动资产处置损失"
    // },
    {
        item: "三、利润总额（亏损总额以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "19",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行次：行13+行14-行16"
    },
    {
        item: "减：所得税费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "20",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "科目：所得税费用"
    },
    {
        item: "四、净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "21",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行次：行18-行19"
    },

    {
        item: "        （一）持续经营净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "22",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "        （二）终止经营净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "23",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "五、其他综合收益的税后净额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "24",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "（一）以后不能重分类进损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "25",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "1.重新计量设定收益计划净负债或净资产的变动",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "26",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "2.权益法下在被投资单位不能重分类进损益的其他综合收益中享有的份额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "27",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "（二）以后将重分类进损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "28",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "1.权益法下在被投资单位以后将重分类进损益的其他综合收益中享有的份额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "29",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "2.可供出售金融资产公允价值变动损益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "30",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "3.将有至到期投资重分类可供出售金融资产损益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "31",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "4.现金流经套期损益的有效部分",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "32",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "5.外币财务报表折算差额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "33",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "六、综合收益总额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "34",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "行20+行23"
    },

    {
        item: "七、每股收益：",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "35",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "（一）基本每股收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "36",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    },
    {
        item: "（二）稀释每股收益：",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "37",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: null
    }
];

const nineteenRule: Income[] = [
    {
        item: "一、营业收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "1",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "（主营业务收入+其他业务收入）实际损益额"
    },
    {
        item: "减：营业成本",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "2",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "（主营业务成本+其他业务成本）实际损益额"
    },
    {
        item: "税金及附加",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "3",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "税金及附加 实际损益额"
    },
    {
        item: "销售费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "4",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "销售费用 实际损益额"
    },
    {
        item: "管理费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "5",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "（管理费用-研发费用） 实际损益额"
    },
    {
        item: "研发费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "6",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "研发费用  实际损益额"
    },
    {
        item: "财务费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "7",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "财务费用 实际损益额"
    },
    {
        item: "其中：利息费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "8",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "利息费用 实际损益额"
    },
    {
        item: "　　　利息收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "9",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "利息收入 实际损益额"
    },
    {
        item: "加：其他收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "10",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "其他收益 实际损益额"
    },
    {
        item: "投资收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "11",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "投资收益 实际损益额"
    },
    {
        item: "其中：对联营企业和合营企业的投资收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "12",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "　　　以摊余成本计量的金融资产终止确认收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "13",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "净敞口套期收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "14",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "净敞口套期收益 实际损益额"
    },
    {
        item: "公允价值变动收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "15",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "公允价值变动损益 实际损益额"
    },
    {
        item: "信用减值损失（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "16",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "信用减值损失"
    },
    {
        item: "资产减值损失（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "17",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "资产减值损失"
    },
    {
        item: "资产处置收益（损失以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "18",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "资产处置损益"
    },
    {
        item: "二、营业利润（亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "19",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "1-2-3-4-5-6-7+10+11+14+15+16+17+18"
    },
    {
        item: "加：营业外收入",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "20",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "营业外收入"
    },

    {
        item: "减：营业外支出",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "21",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "营业外支出"
    },
    {
        item: "三、利润总额（亏损总额以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "22",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "19+20-21"
    },
    {
        item: "减：所得税费用",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "23",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "所得税费用"
    },
    {
        item: "四、净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "24",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "22-23"
    },
    {
        item: "（一）持续经营净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "25",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "24"
    },
    {
        item: "（二）终止经营净利润（净亏损以“-”号填列）",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "26",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "五、其他综合收益的税后净额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "27",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "（一）不能重分类进损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "28",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "1. 重新计量设定受益计划变动额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "29",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "2. 权益法下不能转损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "30",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "3. 其他权益工具投资公允价值变动",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "31",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "4. 企业自身信用风险公允价值变动",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "32",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "（二）将重分类进损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "33",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },

    {
        item: "1. 权益法下可转损益的其他综合收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "34",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "2. 其他债权投资公允价值变动",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "35",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "3. 金融资产重分类计入其他综合收益的金额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "36",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "4. 其他债权投资信用减值准备",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "37",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "5. 现金流量套期储备",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "38",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "6. 外币财务报表折算差额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "39",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "六、综合收益总额",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "40",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: "24+27"
    },
    {
        item: "七、每股收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "41",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "（一）基本每股收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "42",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    },
    {
        item: "（二）稀释每股收益",
        oneQuarterCash: "0",
        twoQuarterCash: "0",
        threeQuarterCash: "0",
        fourQuarterCash: "0",
        row: "43",
        yearCash: "0",
        monthCash: "0",
        lastYearMonthCash: "0",
        fomularDetail: ""
    }
];

const getData = (book: AccountBookList.AccountBook) => {
    switch(book.accountingSystem) {
        case AccountingSystem.thirteenRule: return thirteenRule;
        case AccountingSystem.nineteenRule: return nineteenRule;
        case AccountingSystem.sevenNormal: return sevenRule;
        default: return thirteenRule;
    }
}

const incomeData = {
    thirteenRule,
    sevenRule,
    nineteenRule,
    getData
};

export default incomeData;